module.exports = __webpack_public_path__ + "img/C08TechRangerChampion_ua.9274cd91.webp";